import { Tabs, Tab } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import FEATURE_FLAGS from "src/utils/constants/featureFlags";
import __ from "src/utils/Translations";

const DashboardTabs = () => {
  const location = useLocation();

  const isDashboardWidgetsEnabled = useFeatureIsOn(FEATURE_FLAGS.DASHBOARD_WIDGETS);
  const isDashboardMenuConfigurationEnabled = useFeatureIsOn(FEATURE_FLAGS.DASHBOARD_MENU_CONFIGURATION);
  const isDashboardEmployeeProfileEnabled = useFeatureIsOn(FEATURE_FLAGS.DASHBOARD_EMPLOYEE_PROFILE);
  const isDashboardModulesVisibilityConfigurationEnabled = useFeatureIsOn(FEATURE_FLAGS.DASHBOARD_MODULES_VISIBILITY_CONFIGURATION);

  const baseUrl = location.pathname.replace(
    /\/(widgets|menu-configuration|employee-profile|modules-visibility-configuration).*$/,
    ""
  );

  const tabs = [
    { label: __("Widżety"), path: `${baseUrl}/widgets`, enabled: isDashboardWidgetsEnabled },
    { label: __("Konfiguracja menu"), path: `${baseUrl}/menu-configuration`, enabled: isDashboardMenuConfigurationEnabled },
    { label: __("Profil użytkownika"), path: `${baseUrl}/employee-profile`, enabled: isDashboardEmployeeProfileEnabled },
    { label: __("Podgląd widoczności modułów"), path: `${baseUrl}/modules-visibility-configuration`, enabled: isDashboardModulesVisibilityConfigurationEnabled },
  ].filter((tab) => tab.enabled);

  const activeTab =
    tabs.find((tab) => location.pathname.startsWith(tab.path))?.path ?? false;

  return (
    <Tabs
      value={activeTab}
      sx={{ "& .MuiTab-root": { "&:hover": { textDecoration: "none" } } }}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.path}
          label={tab.label}
          component={NavLink}
          to={tab.path}
          value={tab.path}
        />
      ))}
    </Tabs>
  );
};

export default DashboardTabs;
